module.exports = __webpack_public_path__ + "static/img/fwhx2.35bd5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/B1/fwhx2.png
// module id = NsKS
// module chunks = 0